import { defineCopy } from './index';

export const welcomeCopy = defineCopy('welcome', {
  title: 'Welcome to the run.',
  body: 'Got a crew code from a friend? Paste it or type it in.',
  paste: 'Paste code',
  pasteEmpty: 'Nothing on the clipboard looks like a code.',
  pasteBlocked: 'Paste is blocked here. Type the code instead.',
  codeLabel: 'Crew code',
  codePlaceholder: 'XXXX-XXXX',
  codeHint: 'Eight letters and numbers. Capitals, hyphen and spaces do not matter.',
  check: 'Check code',
  checking: 'Checking...',
  invitedBy: '{name} invited you to {crew}.',
  invitedCrew: "You're joining {crew}.",
  joiningAs: "You're joining as {name}. Their stats come with you.",
  personalTitle: 'Your own invite',
  nameLabel: 'Your name',
  namePlaceholder: 'What the crew calls you',
  nicknameLabel: 'Nickname (optional)',
  join: 'Join the crew',
  joining: 'Joining...',
  joined: "You're in. Try not to drag the average down.",
  badCode: "That code doesn't work. Ask the crew for a fresh one.",
  tooMany: 'Too many tries. Take a breath and try again in a few minutes.',
  relogin: {
    toggle: 'Lost your spot? Use a comeback code',
    title: 'Back in the game.',
    body: 'New phone, reinstalled the app, wiped your data? A crewmate can get you back in.',
    steps: [
      'Ask any crewmate to open the app, go to Crew and tap your name.',
      'They tap Get them back in and read you six letters and numbers.',
      'Type them here within 15 minutes.',
    ],
    label: 'Comeback code',
    help: 'Six characters from a crewmate, eight from the rescue command. Works once.',
    action: 'Get back in',
    acting: 'Getting you back in...',
    short: 'That is shorter than six characters.',
    joinInstead: 'I have a crew code instead',
    owner:
      'Owner locked out? The server has a rescue command that prints an eight character code. It works in the same box.',
  },
  bootstrap: {
    toggle: 'Setting up the app for the first time?',
    label: 'Owner setup token',
    help: 'The token from the server setup. Only works once.',
    action: 'Claim the app',
  },
  back: 'Back',
  offline: 'No signal. Joining needs one bar, so find a spot near the door.',
  failed: 'Something broke on our end. Try again in a sec.',
});
